import React, { useEffect, useState, useRef } from "react";
import { Box } from "@mui/material";
import { useMobileDetect } from "../../hooks";

export const Gamification = () => {
    const containerRef = useRef(null);
    const [pdfLoaded, setPdfLoaded] = useState(false);

    const isMobile = useMobileDetect();
    const documentPdf = isMobile ? '/gamification_mobile.pdf' : '/gamification.pdf';

    useEffect(() => {
        if (!containerRef.current) return;

        if (!window.pdfjsLib) {
            const script = document.createElement("script");
            script.src = "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.4.120/pdf.min.js";
            script.async = true;
            script.onload = () => {
                const workerScript = document.createElement("script");
                workerScript.src = "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.4.120/pdf.worker.min.js";
                workerScript.async = true;
                workerScript.onload = () => {
                    setPdfLoaded(true);
                };
                document.head.appendChild(workerScript);
            };
            document.head.appendChild(script);
        } else {
            setPdfLoaded(true);
        }
    }, []);

    useEffect(() => {
        if (!pdfLoaded || !containerRef.current) return;

        try {
            const pdfjsLib = window.pdfjsLib;
            pdfjsLib.GlobalWorkerOptions.workerSrc =
                "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.4.120/pdf.worker.min.js";

            containerRef.current.innerHTML = "";

            const viewer = document.createElement("div");
            viewer.style.width = "100%";
            viewer.style.height = "100%";
            viewer.style.padding = "0";
            viewer.style.position = "relative";
            viewer.style.zIndex = "1000";
            viewer.style.backgroundColor = "white";
            viewer.style.overflowY = "auto";
            viewer.style.overflowX = "hidden";
            viewer.style.webkitOverflowScrolling = "touch";
            containerRef.current.appendChild(viewer);

            pdfjsLib
                .getDocument(documentPdf)
                .promise.then((pdf) => {
                    const numPages = pdf.numPages;

                    for (let i = 1; i <= numPages; i++) {
                        renderPage(pdf, i, viewer);
                    }
                })
                .catch((error) => {
                    console.error(error);
                    useFallbackViewer();
                });
        } catch (error) {
            console.error("Erro ao inicializar PDF.js:", error);
            useFallbackViewer();
        }

        function renderPage(pdf, pageNumber, container) {
            return pdf.getPage(pageNumber).then((page) => {
                const viewport = page.getViewport({ scale: 1.0 });
                const containerWidth = container.clientWidth || window.innerWidth;
                const scale = containerWidth / viewport.width;
                const scaledViewport = page.getViewport({ scale });

                const pageContainer = document.createElement("div");
                pageContainer.style.position = "relative";
                pageContainer.style.margin = "0";
                pageContainer.style.width = `${scaledViewport.width}px`;
                pageContainer.style.height = `${scaledViewport.height}px`;
                pageContainer.style.imageRendering = "crisp-edges";
                pageContainer.style.pageBreakAfter = "always";
                container.appendChild(pageContainer);

                const canvas = document.createElement("canvas");
                const context = canvas.getContext("2d");
                const devicePixelRatio = window.devicePixelRatio || 1;
                canvas.width = scaledViewport.width * devicePixelRatio;
                canvas.height = scaledViewport.height * devicePixelRatio;
                canvas.style.width = `${scaledViewport.width}px`;
                canvas.style.height = `${scaledViewport.height}px`;
                context.imageSmoothingEnabled = true;
                context.imageSmoothingQuality = 'high';
                pageContainer.appendChild(canvas);

                return page
                    .render({
                        canvasContext: context,
                        viewport: scaledViewport,
                        intent: "display",
                        transform: [devicePixelRatio, 0, 0, devicePixelRatio, 0, 0],
                    })
                    .promise.then(() => {
                        if (pageNumber === pdf.numPages) {
                            const spacer = document.createElement("div");
                            spacer.style.height = "100px";
                            spacer.style.width = "1px";
                            container.appendChild(spacer);
                        }
                    });
            });
        }

        function useFallbackViewer() {
            if (!containerRef.current) return;
            containerRef.current.innerHTML = `
                <iframe src="${documentPdf}" style="width:100%; height:100%; border:0; margin:0; padding:0;" allowfullscreen></iframe>
            `;
        }

        return () => {
            if (containerRef.current) {
                containerRef.current.innerHTML = "";
            }
        };
    }, [pdfLoaded]);

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                height: "100vh",
                overflow: "hidden",
                position: "relative",
                zIndex: "1",
                margin: 0,
                padding: 0,
                border: 0,
            }}
        >
            <div
                ref={containerRef}
                style={{
                    width: "100%",
                    height: window.innerWidth < 768 ? "calc(100vh - 70px)" : "100%",
                    border: 0,
                    margin: 0,
                    padding: 0,
                    overflowY: "auto",
                    WebkitOverflowScrolling: "touch",
                }}
            />
        </Box>
    );
};
